import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import WrappedFooter from "../../components/WrappedFooter.jsx";
import EnhancedSearchResults from "../../components/enhancedSearch/SearchResults/EnhancedSearchResults";
import SearchPagination from "../../components/enhancedSearch/SearchResults/SearchPagination.jsx";
import EnhancedSearchFilterSideBar from "../../components/enhancedSearch/SearchResults/SearchResultsFilterSideBar.jsx";
import styles from "./EnhancedSearchResultsPage.module.scss";
import useIsWebScreen from "../../hooks/useScreenSize.js";
import ModernWebLayout from "../../components/Layout/ModernWebLayout.jsx";
import MainContent from "../../components/Layout/MainContent.jsx";
import AnimatedPopup from "../../components/AnimatedComponents/AnimatedPopup.jsx";
import { normalizeSearchTerm } from "../../components/enhancedSearch/SearchResults/SearchResultsFilterSideBar.jsx";
import { selectTopicResults } from "./enhancedSearchSlice.js";
import { updateUser } from "../counter/counterSlice.js";

const TopicToolsSticky = React.lazy(
  () => import("../../components/topicToolsSticky.jsx"),
);

const ModernEnhancedSearchResultsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const search = location.search;

  const { isDesktop } = useIsWebScreen();
  const searchResults = useSelector(selectTopicResults);

  const [selectedTab, setSelectedTab] = useState(0);
  const [showFilterBar, setShowFilterBar] = useState(false);
  const [filterNumber, setFilterNumber] = useState(0);
  const [allGuidelines, setAllGuidelines] = useState({});
  const [initialGuidelines, setInitialGuidelines] = useState({});

  // applied search terms
  const [lastAppliedSearchTerm, setLastAppliedSearchTerm] = useState("");
  // typing for "search within"
  const [searchWithin, setSearchWithin] = useState("");
  const [updateFilters, setUpdateFilters] = useState(false);
  useEffect(() => {
    if (searchResults?.guidelineFacets) {
      if (updateFilters) {
        setInitialGuidelines(searchResults.guidelineFacets);
        setAllGuidelines(searchResults.guidelineFacets);
        setUpdateFilters(false);
      } else {
        const updated = { ...initialGuidelines };
        Object.entries(searchResults.guidelineFacets).forEach(([k, v]) => {
          updated[k] = v;
        });
        setInitialGuidelines(updated);
        setAllGuidelines(updated);
      }
    }
  }, [searchResults?.guidelineFacets, updateFilters]);
  return (
    <ModernWebLayout title="Page Title">
      <MainContent className={styles.styledMainContent} padding="default">
        <div id="tgsearch">
          <div className={styles.mainContent}>
            <EnhancedSearchResults
              search={search}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              showFilterBar={showFilterBar}
              setShowFilterBar={setShowFilterBar}
            />

            {showFilterBar ? (
              !isDesktop ? (
                <AnimatedPopup show={showFilterBar}>
                  <EnhancedSearchFilterSideBar
                    search={search}
                    navigate={navigate}
                    setShowFilterBar={setShowFilterBar}
                    setFilterNumber={setFilterNumber}
                    className={styles.filterSidebar}
                    allGuidelines={allGuidelines}
                    lastAppliedSearchTerm={lastAppliedSearchTerm}
                    setLastAppliedSearchTerm={setLastAppliedSearchTerm}
                    searchWithin={searchWithin}
                    setSearchWithin={setSearchWithin}
                    setUpdateFilters={setUpdateFilters}
                  />
                </AnimatedPopup>
              ) : (
                <EnhancedSearchFilterSideBar
                  search={search}
                  navigate={navigate}
                  setShowFilterBar={setShowFilterBar}
                  setFilterNumber={setFilterNumber}
                  className={styles.filterSidebar}
                  allGuidelines={allGuidelines}
                  setLastAppliedSearchTerm={setLastAppliedSearchTerm}
                  searchWithin={searchWithin}
                  setSearchWithin={setSearchWithin}
                  setUpdateFilters={setUpdateFilters}
                />
              )
            ) : (
              <div className={styles.filterButtonContainer}>
                <button
                  type="button"
                  onClick={() => setShowFilterBar(true)}
                  className={styles.filterButton}
                >
                  <i className="tg-icons-Filters size-14"></i>
                  <span className={styles.filterButtonText}>Filters</span>
                  {filterNumber > 0 && (
                    <div className={styles.counter}>{filterNumber}</div>
                  )}
                </button>
              </div>
            )}
          </div>

          <SearchPagination selectedTab={selectedTab} />
          <TopicToolsSticky pathname={pathname} />
          <WrappedFooter />
        </div>
      </MainContent>
    </ModernWebLayout>
  );
};

export default ModernEnhancedSearchResultsPage;
